// extracted by mini-css-extract-plugin
export default {"ratio":"gallery_ratio__M69IA","galleryItem":"gallery_galleryItem__3Fvyt","grid":"gallery_grid__-trYj","fade-in":"gallery_fade-in__jlU7x"};